module.exports = require("./ar-LY.d.ts");